import styled from '@emotion/styled'

/**
 * Marks the 10x option in the account-type list, so the client can tell it apart from the
 * standard MT5 Classic offered right next to it (PT-6510).
 */
export const TauroBadge = styled.div`
  align-items: center;
  background: #FDF0DC;
  border-radius: 4px;
  color: #8A5A00;
  display: flex;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.4px;
  line-height: 24px;
  padding: 2px 10px;
`
